import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const SAMSUNG_PAY: PaymentMethod = {
    id: PAYMENT_METHOD_ID.SamsungPay,
    name: 'samsungpay',
    tokenRequired: true
};
